import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogLookupPermissionsComponent } from 'src/app/+home/+my-libraries/+sites/document-library/shared/dialog-lookup-permissions/dialog-lookup-permissions.component';
import { WorkflowService } from '../../services/workflow.service';
import { NotificationAuthority, NotificationAuthorityType } from 'src/app/notifications/interfaces/notification-base.interface';
import { UserService } from 'src/shared/services/user/user.service';
import { AlertsNotificationsService } from 'src/app/notifications/services/alerts-notifications.service';
import { WorkflowNotificationService } from 'src/app/notifications/services/workflow-notification.service';

@Component({
  selector: 'modal-ask-workflow',
  templateUrl: './modal-ask-workflow.component.html',
  styleUrls: ['./modal-ask-workflow.component.scss']
})
export class ModalAskWorkflowComponent implements OnInit {
  public formG: FormGroup;
  public loadingRequest: boolean;
  public doDisplaySignature: boolean;
  public userids: string[] = [];
  constructor(private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private workflowService: WorkflowService,
    private userService: UserService,
    private notificationService: WorkflowNotificationService,
    public dialogRef: MatDialogRef<ModalAskWorkflowComponent>) { }

  ngOnInit(): void {
    this.formG = this.fb.group({
      type: ['', Validators.required],
      peoples: [[], Validators.required]
    });

    this.doDisplaySignature = !this.data.properties['ng:signedOn'];
  }

  openUsers() {
    const dialogRef = this.dialog.open(DialogLookupPermissionsComponent, {
      width: '70%',
      height: '55%',
      data: { onlyUsers: true, hidePermissions: true}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.length) {
        return;
      }

      const newPeoples = [...result, ...this.formG.get('peoples').value].filter((user, index, self) =>
        index === self.findIndex((t) => (
          t.id === user.id
        ))
      );

    

      // TODO Modifier ça pour prendre en compte plusieurs users une fois qu'on pourra le gérer côté back
      // Juste retirer [... ]
      this.formG.get('peoples').setValue([newPeoples[0]]);
    });
  }

  async validate() {
    const { type, peoples } = this.formG.value;
    this.loadingRequest = true;
  
    
    const authorities: NotificationAuthority[] = [];
    peoples.forEach(user => {
      authorities.push({
        type: NotificationAuthorityType.Single,
        value: user.properties['cm:userName']
      });
    });


 

    const notificationData = {
      domain: 'workflow',
      content: {
        fileName: this.data.properties['cm:title'],
        nodeRef: 'workspace://SpacesStore/' + this.data.nodeId,
        type: type
      },
      authorities: authorities,
      metadata: {
        creator: this.userService.user.id
      }
    };

    
  
    this.workflowService.createWorkflow({
      assignee: peoples[0].properties['cm:userName'],
      nodeRef: this.data.nodeId,
      processKey: type
    }).then((res)=>{
    this.notificationService.notifyCreated(notificationData);
    });
    this.loadingRequest = false;

    this.dialogRef.close(true);
  }
}
